// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-container[data-v-74062f9c]{margin-top:5px}.alert[data-v-74062f9c]{margin-bottom:5px}.reload-link[data-v-74062f9c]{font-size:16px;border:none;background:none;cursor:pointer;padding:0;color:#0696d7;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
